import { HubConnectionBuilder, HubConnection, LogLevel } from '@microsoft/signalr'
import { getBaseUrl } from './api/client'

let discussionConnection: HubConnection | null = null
let notificationConnection: HubConnection | null = null

export function getDiscussionConnection(): HubConnection {
  if (!discussionConnection) {
    discussionConnection = new HubConnectionBuilder()
      .withUrl(`${getBaseUrl()}/hubs/discussion`)
      .withAutomaticReconnect([0, 1000, 5000, 10000, 30000])
      .configureLogging(LogLevel.Warning)
      .build()
    discussionConnection.serverTimeoutInMilliseconds = 120000
    discussionConnection.keepAliveIntervalInMilliseconds = 30000
  }
  return discussionConnection
}

export function getNotificationConnection(): HubConnection {
  if (!notificationConnection) {
    notificationConnection = new HubConnectionBuilder()
      .withUrl(`${getBaseUrl()}/hubs/notifications`)
      .withAutomaticReconnect([0, 1000, 5000, 10000, 30000])
      .configureLogging(LogLevel.Warning)
      .build()
    notificationConnection.serverTimeoutInMilliseconds = 120000
    notificationConnection.keepAliveIntervalInMilliseconds = 30000
  }
  return notificationConnection
}
